// -*- Mode: rjsx -*-
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ResponseOption, ResponseTextEntry, getCacheKey, clearCache, doQuestion } from '..';
import { updateRequest } from '../../request';

import { FancyTextEntry } from '../../../ui';
import QuestionIcon from '@mui/icons-material/LiveHelp';

import { API } from '../../../api';


function QuestionSheet(props) {
    const dispatch = useDispatch();    

    const [sending, setSending] = useState(false);    
    const [text, setText] = useState(null);
    const cacheKey = getCacheKey(props);
    
    function change(value, numberOfIssues) {
        setText(value);
    }
    
    function send(requestKey) {
        setSending(true);
        console.log("Do send!!!");

        dispatch(doQuestion({
            requestKey: requestKey,
            text: text
        })).then((data) => {
            console.log("data: %o", data);            
            console.log("dispatch: %o", dispatch);
            console.log("clear cache: %o", clearCache(cacheKey));
            dispatch(clearCache(cacheKey));
            dispatch(updateRequest(data.payload.request));
            setSending(false);

            console.log("would redirect");
            if(props.onResponseSuccess)
                props.onResponseSuccess(data);
            
        });

    }
    
    return (
        <ResponseTextEntry
          onSend={send}
          sending={sending}
          sendButtonTitle="Ask the Client"
          onChange={change}
          {...props} />        
    );
}

function QuestionResponse(props) {
    props = {type: "question",
             primary: "Ask the client a question",
             secondary: "Can't complete without extra information",
             icon: <QuestionIcon />,
             ...props};
    return (
        <ResponseOption
          {...props }
          sheet={<QuestionSheet {...props}  />}
         />
    );
}



export { QuestionResponse };
